import { HeNotification } from '../../../../../common/components/HeNotification/HeNotification';

export const BulkBillingInfobox = () => (
  <HeNotification hasIcon>
    Bulk billing rebates may not apply to telehealth consults. Generally, you need to have had a
    face-to-face consult at the same practice within the 12-months prior to your telehealth consult.
  </HeNotification>
);
